const MAX_DIVERGENT_ATTEMPTS = 2;

export {MAX_DIVERGENT_ATTEMPTS};
